import { render } from "./LayoutTop.vue?vue&type=template&id=2ce3e646&scoped=true&class=parent"
import script from "./LayoutTop.vue?vue&type=script&lang=js"
export * from "./LayoutTop.vue?vue&type=script&lang=js"

import "./LayoutTop.vue?vue&type=style&index=0&id=2ce3e646&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LMPELCHAT\\Documents\\vie-associative\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce3e646"]])

export default __exports__